import React, { SyntheticEvent } from "react";

import { Dropdown, Form, FormField, FormGroup, Input } from "semantic-ui-react";

import SearchBoxWithKey from "react-lib/appcon/common/SearchBoxWithKey";

import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";
import DateTextBox from "react-lib/apps/common/DateTextBox";
import TimeComboBox from "react-lib/apps/common/TimeComboBox";

import { LOG_TYPES_OPTIONS } from "./HRMInterface";

import {
  SetProp,
  State,
  ClockRecordType,
} from "./sequence/EmployeeTA";

// Types
type ModAddTimeManuallyProps = {
  onEvent: (e: any) => any;
  setProp: SetProp;
  EmployeeTASequence: State["EmployeeTASequence"];
  open: boolean;
  searchedItemListWithKey: any;
  onAdd: () => void;
  onClose: () => void;
  onChange: (e: SyntheticEvent | null, data: Record<string, any>) => void;
  addData: ClockRecordType;
};

const ModAddTimeManually = (props: ModAddTimeManuallyProps) => {
  // console.log();

  return (
    <ModConfirmCNMI
      testId="-AddManually"
      approveButtonColor="green"
      approveButtonStyle={{ minWidth: "max-content" }}
      approveButtonText="ADD"
      onApprove={props.onAdd}
      backgroundColor="rgba(93, 188, 210, 1)"
      denyButtonText="CLOSE"
      modalStyle={{ minWidth: "35rem" }}
      openModal={props.open}
      titleName={"Add time manually"}
      onCloseWithDimmerClick={props.onClose}
      onDeny={props.onClose}
      content={
        <Form>
          <FormGroup style={{ marginTop: "-1rem" }} inline>
            <FormField width={12} required>
              <label style={{ fontWeight: "normal", minWidth: "75px" }}>Employee : </label>
              <SearchBoxWithKey
                onEvent={props.onEvent}
                id="AddEmployee"
                placeholder="Search Employee"
                type="UserEmployee"
                inline
                searchedItemListWithKey={props.searchedItemListWithKey}
                selectedItem={props.addData?.employee || null}
                setSelected={(value) => {
                  props.setProp("EmployeeTASequence.addManual.employee", value)
                }}
              />
            </FormField>
          </FormGroup>
          <FormGroup inline>
            <FormField width={12} required>
              <label style={{ fontWeight: "normal", minWidth: "75px" }}>Log type : </label>
              <Dropdown
                id="ModAddTimeManually-Dropdown-LogType"
                style={{ width: "100%" }}
                fluid
                search
                selection
                options={LOG_TYPES_OPTIONS}
                name="type"
                onChange={props.onChange}
                value={props.addData?.type}
              />
            </FormField>
          </FormGroup>
          <FormGroup inline>
            <FormField width={9} inline>
              <label style={{ fontWeight: "normal", minWidth: "75px" }}>Date : </label>
              <div style={{ width: "100%" }}>
                <DateTextBox
                  id="ModAddTimeManually-DateTextBox-Date"
                  onChange={(value: any) => props.onChange?.(null, { name: "date", value })}
                  value={props.addData?.date}
                />
              </div>
            </FormField>
            <FormField width={7} inline>
              <label id="ModAddTimeManually-Label-Time" style={{ fontWeight: "normal", minWidth: "max-content" }}>Time : </label>
              <TimeComboBox
                id="ModAddTimeManually-TimeComboBox-Time"
                style={{ width: "100%" }}
                defaultValue={props.addData?.time}
                onTextChange={(value: any) => props.onChange?.(null, { name: "time", value })}
              />
            </FormField>
          </FormGroup>
          <FormGroup style={{ marginBottom: "-1rem" }} inline>
            <FormField width={16} required>
              <label style={{ fontWeight: "normal", minWidth: "75px" }}>Reason : </label>
              <Input
                id="ModAddTimeManually-Input-Reason"
                fluid
                name="reason"
                onChange={props.onChange}
                value={props.addData?.reason}
              />
            </FormField>
          </FormGroup>
        </Form>
      }
    />
  );
};

ModAddTimeManually.displayName = "ModAddTimeManually";

export default React.memo(ModAddTimeManually);
